import { render, staticRenderFns } from "./situationtable.vue?vue&type=template&id=0ff38fc8&scoped=true&"
import script from "./situationtable.vue?vue&type=script&lang=js&"
export * from "./situationtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff38fc8",
  null
  
)

export default component.exports